// src/data/gyms/AList.js
export const AList = {
  id: "alist",
  name: "A-List Athletics",
  color: "#FACC15", // Gold
  lightColor: "#FEFCE8",
  logo: "⭐️",

  teams: [
    {
      id: "littlelavish",
      name: "Little Lavish",
      level: "L1 Tiny - Novice",
    },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "9:59 AM", // Floor compete
      teamId: "littlelavish",
      meet: "9:23 AM", // Check-in
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    // No performance listed for Sunday (One-day comp for Tiny Novice)
  ],
};
